import React, { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import GlobalContext from '../../../main/utils/GlobalContext';

const EstablishmentBlockList = ({ establishmentId }) => {
  const { locales } = useContext(GlobalContext);
  const {
    blocks: { data },
  } = useSelector((state) => state);

  const {
    blocks: { fetchBlock },
  } = useDispatch();

  useEffect(() => {
    if (establishmentId) {
      fetchBlock({
        by: 'establishments',
        byId: establishmentId,
        pageName: 'admin',
      });
    }
  }, [establishmentId]);

  return (
    <div className="establishment-block-list">
      <div className="establishment-block-list__row">
        <div className="establishment-block establishment-block__fg3">
          <div className="establishment-block__header">
            {locales.admin.students}
          </div>
          <div className="establishment-block__items">
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.totalProject}
              </div>
              <div className="establishment-block__title">
                {locales.admin.totalProjects}
              </div>
            </div>
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.totalStudents}
              </div>
              <div className="establishment-block__title">
                {locales.admin.totalStudents}
              </div>
            </div>
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.totalLastActiveStudents}
              </div>
              <div className="establishment-block__title">
                {locales.admin.activeLast30Days}
              </div>
            </div>
          </div>
        </div>
        <div className="establishment-block establishment-block__fg3">
          <div className="establishment-block__header">
            {locales.admin.totalProgress}
          </div>
          <div className="establishment-block__items">
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.ideasCount}
              </div>
              <div className="establishment-block__title">
                {locales.admin.ideasCreated}
              </div>
            </div>
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.canvasProgress}
              </div>
              <div className="establishment-block__title">
                {locales.admin.canvasProgress}
              </div>
            </div>
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.testsCompleted}
              </div>
              <div className="establishment-block__title">
                {locales.admin.testsCompleted}
              </div>
            </div>
          </div>
        </div>
        <div className="establishment-block establishment-block__fg2">
          <div className="establishment-block__header">
            {locales.admin.activity}
          </div>
          <div className="establishment-block__items">
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.totalSiteTimeTracks}
              </div>
              <div className="establishment-block__title">
                {locales.admin.totalMinutes}
              </div>
            </div>
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.totalSiteLastTotalTracks}
              </div>
              <div className="establishment-block__title">
                {locales.admin.minutesLast30Days}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="establishment-block-list__row">
        <div className="establishment-block establishment-block__fg2">
          <div className="establishment-block__header">
            {locales.admin.classes}
          </div>
          <div className="establishment-block__items">
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.totalClassrooms}
              </div>
              <div className="establishment-block__title">
                {locales.admin.total}
              </div>
            </div>
            <div className="establishment-block__item">
              <div className="establishment-block__value">
                {data.activeClassrooms}
              </div>
              <div className="establishment-block__title">
                {locales.admin.activeLast30Days}
              </div>
            </div>
          </div>
        </div>
        <div className="establishment-block establishment-block__fg6">
          <div className="establishment-block__card">
            <div className="establishment-block__card__item">
              <div className="establishment-block__header">
                {locales.admin.subscription}
              </div>
              <div className="establishment-block__items">
                <div className="establishment-block__item">
                  <div className="establishment-block__value">
                    {data.licenseStartDate === '-'
                      ? '-'
                      : moment(data.licenseStartDate).format('DD MMM YYYY')}
                  </div>
                  <div className="establishment-block__title">
                    {locales.admin.licenseStartDate}
                  </div>
                </div>
                <div className="establishment-block__item">
                  <div className="establishment-block__value">
                    {data.licenseEndDate === '-'
                      ? '-'
                      : moment(data.licenseEndDate).format('DD MMM YYYY')}
                  </div>
                  <div className="establishment-block__title">
                    {locales.admin.licenseEndDate}
                  </div>
                </div>
              </div>
            </div>
            <div className="establishment-block__card__item">
              <div className="establishment-block__header">
                {locales.admin.licenses}
              </div>
              <div className="establishment-block__items">
                <div className="establishment-block__item">
                  <div className="establishment-block__value">
                    {data.licensesMaxCount}
                  </div>
                  <div className="establishment-block__title">
                    {locales.admin.total}
                  </div>
                </div>
                <div className="establishment-block__item">
                  <div className="establishment-block__value">
                    {data.usedUsersCount}
                  </div>
                  <div className="establishment-block__title">
                    {locales.admin.used}
                  </div>
                </div>
                <div className="establishment-block__item">
                  <div className="establishment-block__value">
                    {data.remainingLicensesCount}
                  </div>
                  <div className="establishment-block__title">
                    {locales.admin.remaining}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstablishmentBlockList;
